/* eslint-disable */
import { createSelector } from 'reselect';
import ordersSelector from './Orders.selector';

/**
 * Select the currently selected order loading status
 * @returns {OrderEntity | null} The loading status of the currently selected `order` that has been selected from the store
 */
const ordersSelectedLoadingSelector = createSelector(ordersSelector, (orders) => orders.selectedIdLoading);

export default ordersSelectedLoadingSelector;
